module.exports = __webpack_public_path__ + "img/lever07.c2e011e3.png";